import { useEffect, useReducer, useState } from "react";
import { CSVLink } from "react-csv";

const csvReducer = (state, action) => {
  switch (action.type) {
    case "SET_CSV":
      return {
        ...action.csv,
      };
    case "SET_UPDATING":
      return {
        ...state,
      };
    case "STOP_UPDATING":
      return {
        ...state,
      };
    default:
      return state;
  }
};

const useCsvInput = () => {
  const [csv, dispatch] = useReducer(csvReducer, {
    headers: [],
    data: [],
    desc: "",
    updating: false,
  });
  const input = (
    <div className="flex text-center ">
      <CSVLink
        className=" h-full bg-blue-500 px-1 py-1 text-xs text-white font-semibold rounded-lg shadow-lg"
        data={csv.data}
        headers={csv.headers}
        filename={`${csv.desc}.csv`}
      >
        Download Excel
      </CSVLink>
    </div>
  );

  return [dispatch, input];
};
export default useCsvInput;
